import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSquareBehindSquare3"><Path fillRule="evenodd" clipRule="evenodd" d="M16 8V3.25C16 2.55964 15.4404 2 14.75 2H3.25C2.55964 2 2 2.55964 2 3.25V14.75C2 15.4404 2.55964 16 3.25 16H8V20.75C8 21.4404 8.55964 22 9.25 22H20.75C21.4404 22 22 21.4404 22 20.75V9.25C22 8.55964 21.4404 8 20.75 8H16ZM14.75 16C15.4404 16 16 15.4404 16 14.75V9.5H20.5V20.5H9.5V16H14.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare3;
